// Constants.
import * as StatsChartsConstants from 'constants/StatsChartsConstants';
import * as AuthConstants from 'constants/AuthConstants';
import * as ErrorConstants from 'constants/ErrorConstants';

const initialState = {
  isFetched: false,
  isFetching: false,
  charts: [],
};

export default function charts(state = initialState, action = {}) {
  switch (action.type) {
    case StatsChartsConstants.LOAD_CHARTS_CHARTS_REQUEST:
      return {
        ...state,
        isFetched: initialState.isFetched,
        isFetching: true,
      };
    case StatsChartsConstants.LOAD_CHARTS_CHARTS_SUCCESS: {
      const charts = [ ...action.chartsCharts ];
      charts.map((chart, index) => {
        const chartFlows = [];
        chart.chart_flows.map((chartFlow) => {
          if (chartFlow.source === 'welltory') {
            chartFlows.push(chartFlow);
          }
        });
        charts[index].chartFlows = chartFlows;
      });

      return {
        ...state,
        isFetched: true,
        isFetching: false,
        charts: charts,
      };
    }
    case AuthConstants.LOGOUT_SUCCESS:
    case AuthConstants.LOGOUT_TOKEN_SUCCESS:
    case ErrorConstants.LOAD_REQUEST_FAILURE:
      return {
        ...state,
        isFetched: false,
        chartsConfig: initialState.chartsDataFlow,
      };
    default:
      return state;
  }
}
